module.exports = __webpack_public_path__ + "static/media/discountDark.1160930d.svg";